import { render, staticRenderFns } from "./PlatformReports.vue?vue&type=template&id=7645b032&"
import script from "./PlatformReports.vue?vue&type=script&lang=js&"
export * from "./PlatformReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports